// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"447":"3e7eee2b","453":"33a22bf2","967":"f9459f0d"}[chunkId] + ".chunk.js";
};